module.exports = __webpack_public_path__ + "img/i.9e313033.jpg";